import { auth } from './firebase';
import type { AnalyzeResponse, UserSettings } from '../types';

const API_BASE = import.meta.env.VITE_API_URL || 'https://api-2yzj3widaa-uc.a.run.app';

async function getAuthHeaders(): Promise<HeadersInit> {
    const user = auth.currentUser;
    if (user) {
        const token = await user.getIdToken();
        return {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        };
    }
    return {
        'Content-Type': 'application/json'
    };
}

export async function analyzeImage(imageBase64: string): Promise<AnalyzeResponse> {
    const headers = await getAuthHeaders();

    const response = await fetch(`${API_BASE}/analyze`, {
        method: 'POST',
        headers,
        body: JSON.stringify({ image: imageBase64 })
    });

    if (!response.ok) {
        const error = await response.json().catch(() => ({ message: 'Analysis failed' }));
        throw new Error(error.message || 'Analysis failed');
    }

    return response.json();
}

export async function getUserSettings(): Promise<UserSettings | null> {
    const headers = await getAuthHeaders();

    const response = await fetch(`${API_BASE}/user/settings`, {
        method: 'GET',
        headers
    });

    if (!response.ok) {
        if (response.status === 404) {
            return null; // No settings yet
        }
        const error = await response.json().catch(() => ({ message: 'Failed to load settings' }));
        throw new Error(error.message || 'Failed to load settings');
    }

    return response.json();
}

export async function updateUserSettings(settings: UserSettings): Promise<UserSettings> {
    const headers = await getAuthHeaders();

    const response = await fetch(`${API_BASE}/user/settings`, {
        method: 'POST',
        headers,
        body: JSON.stringify(settings)
    });

    if (!response.ok) {
        const error = await response.json().catch(() => ({ message: 'Failed to save settings' }));
        throw new Error(error.message || 'Failed to save settings');
    }

    return response.json();
}
